import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-md-12" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "medicare-part-a-effective-date" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_4 = { class: "input-group date datepickerInput" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "medicare-part-b-effective-date" }, " Medicare Part B Effective Date ", -1 /* HOISTED */)
const _hoisted_9 = { class: "input-group date datepickerInput" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Existing Prior Episodes:", -1 /* HOISTED */)
const _hoisted_14 = { class: "form-group col-12 py-2" }
const _hoisted_15 = { class: "col-12 row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "within-sixty-days",
  class: "col-10"
}, [
  /*#__PURE__*/_createTextVNode(" Patient within their sixty-day period on OUR "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" services. ")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "col-12 row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "service-with-another-agency",
  class: "col-10"
}, " Patient on services with Another Agency. Need Beneficiary Transfer Statement. ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              type: "text",
              name: "medicare-part-a-effective-date",
              class: "form-control",
              value: _ctx.formatDateInput(_ctx.referral.ReferralExtension[_ctx.insurer?.partADate]),
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
              placeholder: "MM/DD/YYYY",
              autocomplete: "off"
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
            _hoisted_6
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["getDate"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              type: "text",
              name: "medicare-part-b-effective-date",
              class: "form-control",
              value: _ctx.formatDateInput(_ctx.referral.ReferralExtension[_ctx.insurer?.partBDate]),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
              placeholder: "MM/DD/YYYY",
              autocomplete: "off"
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10),
            _hoisted_11
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["getDate"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.ReferralExtension[_ctx.insurer?.priorEpisode]) = $event)),
            value: 1,
            name: "existing-prior-episode",
            type: "radio",
            "au-target-id": "791",
            id: "within-sixty-days"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.referral.ReferralExtension[_ctx.insurer?.priorEpisode]]
          ]),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.ReferralExtension[_ctx.insurer?.priorEpisode]) = $event)),
            value: 2,
            name: "existing-prior-episode",
            type: "radio",
            "au-target-id": "791",
            id: "service-with-another-agency"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.referral.ReferralExtension[_ctx.insurer?.priorEpisode]]
          ]),
          _hoisted_18
        ])
      ])
    ])
  ]))
}